export default {
  // LN0020001产品列表
  initEntranceData: {
    url: '/website/home/entranceInit',
    method: 'get',
  },
  // LN0010003获取首页数据
  initLoginData: {
    url: '/website/home/firstPageInit',
    method: 'get',
    // openMock: true,
  },
};



// WEBPACK FOOTER //
// ./src/service/apiConfig/apiLogin.js